<template>
  <div class="membership-select">
    <SubscriptionNotice />
    <div class="app-container">
      <div class="route-container route-container--skinny">
        <Header />
        <div class="route-container-inner">
          <div class="membership-select-header">
            <span>
              Already a member?
              <a href="/auth/requestsignin?returnurl=/register">
                <b>Log in here</b>
              </a>
            </span>
            <div class="membership-select-slider">
              <span
                :class="{ active: priceDisplay === 'Annually' }"
                @click="switchPrices('Annually')"
              >
                Annual Price
              </span>
              <span
                :class="{ active: priceDisplay === 'Monthly' }"
                @click="switchPrices('Monthly')"
              >
                Monthly Price
              </span>
            </div>
          </div>
          <div class="membership-fees">
            <MembershipOptionCard
              v-for="(fee, index) in fees.filter(
                (f) => f.memTypeCode !== 'STF',
              )"
              :key="index"
              :isLarge="index === 0"
              :option="fee"
              :priceDisplay="priceDisplay"
            />
          </div>
        </div>
        <div class="unsure">
          <p>Unsure which membership type is right for you?</p>
          <router-link :to="{ name: 'Wizard' }" class="btn btn--positive">
            Help me choose
          </router-link>
        </div>
      </div>
    </div>
    <spinner />
  </div>
</template>

<script>
import MembershipOptionCard from "@/components/MembershipOptionCard";
import Header from "@/components/MembershipOptionsHeader";
import Spinner from "@/components/Spinner";
import SubscriptionNotice from "@/components/SubscriptionNotice";
import { useMembershipTypes } from "@/helpers/membership";
import { ref } from "@vue/composition-api";

export default {
  name: "SelectMembership",
  components: {
    Header,
    MembershipOptionCard,
    Spinner,
    SubscriptionNotice,
  },
  setup() {
    const priceDisplay = ref("Annually");
    const switchPrices = (newDisplay) => {
      priceDisplay.value = newDisplay;
    };
    const { fees } = useMembershipTypes();

    return {
      priceDisplay,
      switchPrices,
      fees,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/global-variables.scss";
.membership-select {
  &-header {
    line-height: 28px;
    margin-bottom: 8px;
    padding: {
      top: 16px;
      bottom: 16px;
    }

    @media screen and (min-width: $screen-extra-small) {
      align-items: center;
      display: flex;
      justify-content: space-between;
    }

    a {
      text-decoration: none;
    }
  }

  &-slider {
    position: relative;

    @media screen and (min-width: $screen-extra-small) {
      order: -1;
    }

    > span {
      border: 2px solid var(--primary);
      border-radius: 50px;
      cursor: pointer;
      font-size: 10px;
      line-height: 28px;
      padding: 5px 10px;
      position: relative;
      z-index: 1;

      &.active {
        background-color: var(--primary);
        color: #ffffff;
        z-index: 2;
      }

      &:last-of-type {
        left: -15px;
      }

      &:first-child:not(.active) {
        padding-right: 20px;
      }

      &:last-child:not(.active) {
        padding-left: 20px;
      }
    }
  }

  .membership-fees {
    display: grid;
    grid-template-columns: repeat(12, minmax(0, 1fr));
    gap: 2.1875em 1.5em;

    > * {
      grid-column: 1 / -1;

      @media screen and (min-width: $large-tablet) {
        &:not(:first-child) {
          grid-column: span 6 / span 6;
        }
      }
    }
  }

  .unsure {
    margin-top: 32px;
    text-align: center;

    p {
      color: var(--primary);
      display: block;
      font-size: 14px;
      line-height: 28px;
      margin-bottom: 16px;
    }

    .btn {
      min-width: 220px;
    }
  }
}
</style>
